import { render, staticRenderFns } from "./AdminCart.vue?vue&type=template&id=5f157da1&scoped=true"
import script from "./AdminCart.vue?vue&type=script&lang=js"
export * from "./AdminCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f157da1",
  null
  
)

export default component.exports